<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 ml-auto mr-auto" v-if="isLoaded">
        <!--        <div class="text-center h3 section">-->
        <!--          The leaderboard will be released and updated after 10 March.-->
        <!--        </div>-->
        <tabs slot="raw-content" tab-content-classes="tab-content-padding text-center">
          <tab-pane v-for="(task, i) in $store.state.tasks" :key="i">
            <template slot="label">Task {{ i + 1 }}</template>
            <p class="category">{{ task }}</p>
            <div>
              <h5>Phase 1</h5>
              <el-table :data="bestInfo[i]" style="width: 100%" :default-sort="{prop: 'metrics', order: 'descending'}">
                <el-table-column prop="team_name" label="Team Name" min-width="100"></el-table-column>
                <el-table-column prop="upload_date" label="Upload Time" min-width="100"></el-table-column>
                <el-table-column prop="metrics" sortable label="Metrics" min-width="100"
                                 :formatter="formatter"></el-table-column>
                <el-table-column :prop="taskMetrics" sortable :label="taskMetrics" min-width="100"
                                 :formatter="formatter"
                                 v-for="(taskMetrics, j) in taskInfo[i]" :key="j">
                </el-table-column>
              </el-table>
            </div>
            <div class="mt-5">
              <h5>Phase 2</h5>
              <el-table :data="bestInfo2[i]" style="width: 100%" :default-sort="{prop: 'metrics', order: 'descending'}">
                <el-table-column prop="team_name" label="Team Name" min-width="100"></el-table-column>
                <el-table-column prop="implement_date" label="Implement Time" min-width="100"></el-table-column>
                <el-table-column prop="metrics" sortable label="Metrics" min-width="100"
                                 :formatter="formatter"></el-table-column>
                <el-table-column :prop="taskMetrics" sortable :label="taskMetrics" min-width="100"
                                 :formatter="formatter"
                                 v-for="(taskMetrics, j) in taskInfo2[i]" :key="j">
                </el-table-column>
              </el-table>
            </div>
          </tab-pane>
        </tabs>
      </div>
      <div class="my-5 pt-5 ml-auto mr-auto" v-else>
        <div class="row justify-content-center">
          <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>
        </div>
        <div class="row mt-4">
          <p>Loading ...</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {Card, Tabs, TabPane} from '@/components';

export default {
  name: "indexLeader",
  components: {
    // Card,
    Tabs,
    TabPane
  },
  data() {
    return {
      // 状态变量
      isLoaded: false,
      isLoaded2: false,
      // 数据存储
      bestInfo: {},
      taskInfo: {},
      bestInfo2: {},
      taskInfo2: {},

      tableData: [{
        date: '2016-05-02',
        name: 'Team Name',
        address: '...'
      }, {
        date: '2016-05-04',
        name: 'Team Name',
        address: '...'
      }, {
        date: '2016-05-01',
        name: 'Team Name',
        address: '...'
      }, {
        date: '2016-05-03',
        name: 'Team Name',
        address: '...'
      }]
    }
  },
  methods: {
    formatter(row, column, cellValue, index) {
      if (!isNaN(cellValue)) {
        return cellValue.toFixed(3);
      } else {
        return cellValue;
      }
    },

    loadRecord() {
      this.$http.get("/apisocial22/read_record/")
          .then(response => {
            // console.log(response.data);
            this.bestInfo = response.data.best_info;
            this.taskInfo = response.data.task_info;
            this.isLoaded = true;
          })
      this.$http.get("/apisocial22/read_record2/")
          .then(response => {
            // console.log(response.data);
            this.bestInfo2 = response.data.best_info;
            this.taskInfo2 = response.data.task_info;
            this.isLoaded2 = true;
          })
    }
  },
  mounted() {
    this.loadRecord();
  }
}
</script>

<style scoped>

</style>